import { type ReactNode } from 'react';
import { StatCard } from '@/components/ui/stat-card';
import { Skeleton } from '@/components/ui/skeleton';
import { useAuth } from '@/hooks/use-auth';
import { useAnalytics } from '../hooks/use-analytics';
import type { RosterCounts, RosterBucket } from '../hooks/use-analytics';

const GRID = 'grid grid-cols-2 gap-sm sm:grid-cols-4';

function OverviewSkeleton(): ReactNode {
  return (
    <div className="space-y-sm">
      <div className={GRID}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={`l${i}`} className="h-[72px] rounded-xl" />
        ))}
      </div>
      <div className={GRID}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={`r${i}`} className="h-[72px] rounded-xl" />
        ))}
      </div>
    </div>
  );
}

function bucketLabel(b: RosterBucket): string {
  return b.active === b.total ? String(b.total) : `${b.active} (${b.total})`;
}

function LeadsRow({
  data,
}: {
  data: { total: number; today: number; week: number; month: number };
}): ReactNode {
  return (
    <div className={GRID}>
      <StatCard label="Total" value={data.total} accent />
      <StatCard label="Hoy" value={data.today} />
      <StatCard label="Semana" value={data.week} />
      <StatCard label="Mes" value={data.month} />
    </div>
  );
}

function RosterRow({ r }: { r: RosterCounts }): ReactNode {
  return (
    <div className={GRID}>
      <StatCard label="Verifying" value={r.verifying} />
      <StatCard label="Pre-Collectors" value={bucketLabel(r.pre_collectors)} />
      <StatCard label="Collectors" value={bucketLabel(r.collectors)} />
      <StatCard label="Registrados" value={r.registered} />
    </div>
  );
}

export function ProgressOverview(): ReactNode {
  const { data, isLoading } = useAnalytics();
  const { isAdmin } = useAuth();
  if (isLoading) return <OverviewSkeleton />;
  if (!data) return null;
  return (
    <div className="space-y-sm">
      <LeadsRow data={data} />
      {isAdmin && <RosterRow r={data.roster} />}
    </div>
  );
}
